import React from 'react';
import { COVER, TOC } from '../../data/content';

export default function Cover() {
  return (
    <>
      <section className="r25-cover-hero" style={{ background: '#111827', padding: '80px 0 72px', position: 'relative', overflow: 'hidden' }}>
        <div className="r25-section-wrap" style={{ maxWidth: 'var(--max)', margin: '0 auto', padding: '0 40px' }}>
          <div style={{ fontSize: 11, fontWeight: 600, letterSpacing: 4, textTransform: 'uppercase', color: 'var(--g2)', marginBottom: 20 }}>
            {COVER.eyebrow}
          </div>
          <h1 style={{
            fontFamily: 'var(--serif)',
            fontSize: 'clamp(32px,5vw,60px)',
            color: '#fff', lineHeight: 1.1,
            letterSpacing: -1, marginBottom: 16, fontWeight: 600,
          }}>
            {COVER.title}<br />
            <em style={{ color: 'var(--g2)', fontStyle: 'italic' }}>{COVER.titleEm}</em>
          </h1>
          <p style={{ fontSize: 16, color: 'rgba(255,255,255,0.4)', marginBottom: 48 }}>{COVER.sub}</p>
          <div className="r25-cover-letter" style={{
            background: 'rgba(255,255,255,0.04)',
            border: '1px solid rgba(168,213,181,0.12)',
            borderLeft: '3px solid var(--g2)',
            borderRadius: 8, padding: '28px 32px', maxWidth: 600,
          }}>
            {COVER.letter.map((para, i) => (
              <p key={i} style={{
                fontSize: 15, color: i === 0 ? 'var(--g2)' : 'rgba(255,255,255,0.6)',
                lineHeight: 1.8, marginBottom: i < COVER.letter.length - 1 ? 12 : 0,
                fontWeight: i === 0 ? 600 : 400,
              }}>{para}</p>
            ))}
          </div>
        </div>
      </section>

      <div style={{ padding: '48px 0', borderBottom: '1px solid #D1D5DB' }}>
        <div className="r25-section-wrap" style={{ maxWidth: 'var(--max)', margin: '0 auto', padding: '0 40px' }}>
          <div className="r25-grid-4" style={{ display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: 8 }}>
            {TOC.map(item => (
              <a
                key={item.num}
                href={`#${item.href}`}
                style={{
                  display: 'flex', alignItems: 'center', gap: 10,
                  padding: '12px 14px', background: 'var(--gray-lt)',
                  borderRadius: 6, textDecoration: 'none',
                  transition: 'background 0.15s',
                }}
                onMouseEnter={e => e.currentTarget.style.background = 'var(--gpale)'}
                onMouseLeave={e => e.currentTarget.style.background = 'var(--gray-lt)'}
              >
                <span style={{ fontFamily: 'var(--serif)', fontSize: 18, color: 'var(--g2)', minWidth: 24, lineHeight: 1, fontWeight: 600 }}>
                  {item.num}
                </span>
                <span style={{ fontSize: 12, fontWeight: 500, color: 'var(--ink)', lineHeight: 1.3 }}>{item.label}</span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}
